import type { ActivitySubjectDetail } from '@shared/types/activity-feed';
import type {
  AccountThreadRichView,
  ThreadDecisionFocus,
  ThreadTopicSummary,
} from '@shared/types/thread-work';

export const buildThreadDecisionFocus = (params: {
  detail: ActivitySubjectDetail;
  threadState: AccountThreadRichView;
  topic: ThreadTopicSummary;
}): ThreadDecisionFocus | null => {
  const { detail, threadState, topic } = params;
  if (!threadState.threadId || !topic.decision) return null;

  return {
    accountSubjectId: topic.accountSubjectId ?? threadState.accountSubjectId,
    subjectId: topic.primarySubjectId ?? threadState.subjectId,
    accountLabel: detail.subjectLabel,
    threadId: threadState.threadId,
    topicId: topic.id,
    topicTitle: topic.title,
    decisionId: topic.decision.id,
    actionId: topic.proposal?.id ?? null,
    version: topic.version,
    sourceRunId: topic.sourceRunId,
    rationale: topic.decision.reason,
    evidenceRefs: topic.decision.evidenceRefs,
    decisionStatus: topic.decision.status,
    decisionResult: topic.decision.result,
    currentVersion: topic.version,
    isCurrent: true,
  };
};
